import React, { useState, useEffect } from 'react';
import AdminLogin from './AdminLogin'; // AdminLogin importieren
import axios from 'axios';
import socket, { API_BASE_URL, requestState } from './config/socket';
import MapVeto from './components/MapVeto.js';



const AdminView = () => {
  const [teams, setTeams] = useState([]);
  const [authenticated, setAuthenticated] = useState(false);
  const [team1, setTeam1] = useState('Team 1');
  const [team2, setTeam2] = useState('Team 2');


  // Das Admin-Passwort wird nach dem Login im Speicher gehalten, damit RCON-Befehle
  // sich am Backend ausweisen koennen. Es wird nirgends persistiert.
  const [adminPassword, setAdminPassword] = useState('');

  const handleLogin = (password) => {
    setAdminPassword(password);
    setAuthenticated(true);
  };

  // Der Kader kommt aus der Datenbank, nicht mehr aus einer Datei im Frontend.
  const [roster, setRoster] = useState([]);

  useEffect(() => {
    socket.on('roster:state', setRoster);
    socket.emit('roster:state', null, (list) => list && setRoster(list));

    return () => socket.off('roster:state', setRoster);
  }, []);

  // Gemischt wird auf dem Server, damit alle denselben Kader sehen und die
  // Aufteilung einen Neustart uebersteht.
  const generateTeams = () => socket.emit('teams:generate', null, () => {});


  useEffect(() => {
    socket.on('updateTeams', (newTeams) => {
      setTeams(newTeams);
      //  console.log ("feuer")
    });

    // Der Server lehnt Steuer-Events ohne gueltige Admin-Session ab. Das darf
    // nicht stillschweigend passieren, sonst klickt man ins Leere.
    socket.on('auth:denied', ({ event }) => {
      console.warn('Server hat', event, 'abgelehnt');
      alert('Nicht autorisiert - bitte neu einloggen (Seite neu laden).');
    });

    return () => {
      socket.off('updateTeams');
      socket.off('auth:denied');
    };
  }, []);



  const handleOnBlur = () =>{
    console.log('Input blurred')
    console.log(team1)
    socket.emit('updateTeam1', team1);
  };

  const handleChange = (e) => {
    setTeam1(e.target.value);
  }

  const handleOnBlur1 = () =>{
    console.log('Input blurred')
    console.log(team2)
    socket.emit('updateTeam2', team2);
  };

  const handleChange1 = (e) => {
    setTeam2(e.target.value);
  }

  const [checked, setChecked] = React.useState(false);

  const handleChange2 = () => {
    setChecked(!checked);
    socket.emit('ready', !checked);
    socket.emit('fetch_player_stats');
    socket.emit('fetch_playermatch_stats');
    socket.emit('fetch_match_stats');
  };



  const [command, setCommand] = useState('');
  const [response, setResponse] = useState('');

  // const sendCommand = async () => {
  //   try {
  //     const res = await axios.post('http://localhost:4000/send-rcon', { command });
  //     // const res = await axios.post('https://otterschlacht.com/send-rcon', { command });
  //     setResponse(res.data.response);
  //   } catch (error) {
  //     setResponse(`Fehler: ${error.message}`);
  //   }
  // };

  const sendCommand = async (cmd) => {
    try {
      const commandToSend = cmd || command; // Verwende den übergebenen Befehl oder den aktuellen Zustand
      const res = await axios.post(`${API_BASE_URL}/send-rcon`, {
        command: commandToSend,
        password: adminPassword, // Backend prueft das Passwort
      });
      setResponse(res.data.response);
    } catch (error) {
      if (error.response?.status === 401) {
        setResponse('Nicht autorisiert - bitte neu einloggen');
      } else {
        setResponse(`Fehler: ${error.message}`);
      }
    }
  };



  // useEffect(() => {
  //   console.log(teams);  // Dieser Effekt wird ausgeführt, wenn teams sich ändern

  // }, [teams]);



  /* ------------------------------------------------------------ Lobby --- */

  const [lobby, setLobby] = useState({ status: 'closed', claims: [], code: null });
  const [veto, setVeto] = useState(null);

  /* ------------------------------------------------------ Gameserver --- */

  const [settings, setSettings] = useState({});
  const [serverForm, setServerForm] = useState(null); // null = nicht im Bearbeiten
  const [serverError, setServerError] = useState('');

  const startServerEdit = () => {
    setServerForm({
      gameHost: settings.gameHost || '',
      gamePort: settings.gamePort || '27015',
      rconHost: settings.rconHost || '',
      rconPort: settings.rconPort || '27015',
      rconPassword: '',
    });
    setServerError('');
  };

  const saveServer = () => {
    setServerError('');

    socket.emit('settings:update', serverForm, (result) => {
      if (!result || !result.ok) {
        const reasons = {
          host: 'Adresse sieht nicht wie ein Hostname oder eine IP aus.',
          port: 'Port muss zwischen 1 und 65535 liegen.',
        };
        setServerError(reasons[result && result.reason] || 'Speichern fehlgeschlagen.');
        return;
      }
      setServerForm(null);
    });
  };

  const clearRcon = () => {
    if (!window.confirm('RCON-Passwort loeschen?')) return;
    socket.emit('settings:update', { clearRconPassword: true }, () => {});
  };

  useEffect(() => {
    socket.on('lobby:state', setLobby);
    socket.on('veto:state', setVeto);
    socket.on('settings:state', setSettings);
    requestState();

    return () => {
      socket.off('lobby:state', setLobby);
      socket.off('veto:state', setVeto);
      socket.off('settings:state', setSettings);
    };
  }, []);

  const openLobby = () => socket.emit('lobby:open', null, () => {});
  const closeLobby = () => socket.emit('lobby:close', null, () => {});
  const releasePlayer = (playerId) => socket.emit('lobby:release', playerId, () => {});

  const resetLobby = () => {
    if (window.confirm('Alle Anmeldungen und das Veto zuruecksetzen?')) {
      socket.emit('lobby:reset', null, () => {});
    }
  };

  const [deactivated, setDeactivated] = useState([]);


  useEffect(() => {
    socket.on('deactivate', (Newdeactivated) => {
      if (deactivated.length === 0) { // Überprüfen, ob deactivated leer ist
        setDeactivated(Newdeactivated);
        console.log("feuer");
      }
    });
    return () => {
      socket.off('deactivate'); // Hier sollte 'deactivate' statt 'updateTeams' stehen
    };

  }, [deactivated]);


  const deleteMember = (teamIndex, memberIndex) => {
    setTeams((prevTeams) => {
      // Hole das gelöschte Mitglied
      const memberToDelete = prevTeams[teamIndex][memberIndex];

      // Füge das Mitglied zu deactivated hinzu (einmalig!)
      setDeactivated((prevDeactivated) => {
        if (!prevDeactivated.includes(memberToDelete)) {
          const updatedDeactivated = [...prevDeactivated, memberToDelete];
          socket.emit('deactivate', updatedDeactivated); // Sende das aktualisierte Array
          return updatedDeactivated;
        }
        return prevDeactivated;
      });

      // Entferne das Mitglied aus dem Team
      const updatedTeams = prevTeams.map((team, index1) =>
        index1 === teamIndex
          ? team.filter((_, i) => i !== memberIndex) // Entferne das Mitglied
          : team // Unveränderte Teams
      );

      // Sende das neue Team-Array an den Server
      socket.emit('updateTeams', updatedTeams);

      return updatedTeams; // Gib die aktualisierten Teams zurück
    });
  };


  const activateMember = (memberToActivate) => {
    // Aktualisiere deactivated
    setDeactivated((prevDeactivated) => {
      const updatedDeactivated = prevDeactivated.filter((member) => member !== memberToActivate);
      socket.emit('deactivate', updatedDeactivated); // Sende das aktualisierte deactivated-Array
      return updatedDeactivated;
    });

    // Aktualisiere teams
    setTeams((prevTeams) => {
      const updatedTeams = prevTeams.map((team, index) => {
        if (index === 0) {
          return [...team, memberToActivate]; // Füge das Mitglied zum Team 0 hinzu
        }
        return team; // Andere Teams unverändert
      });
      socket.emit('updateTeams', updatedTeams); // Sende das aktualisierte Teams-Array
      return updatedTeams;
    });
  };



  const [showForm, setShowForm] = useState(false);
  const [newUser, setNewUser] = useState({
    name: '',
    nickName: '',
    imgUrl: '',
    steamID: '',
  });


  // null = neuer Spieler, sonst die SteamID des bearbeiteten Spielers.
  const [editingId, setEditingId] = useState(null);
  const [formError, setFormError] = useState('');

  const leeresFormular = { name: '', nickName: '', imgUrl: '', steamID: '' };

  const startAdd = () => {
    setNewUser(leeresFormular);
    setEditingId(null);
    setFormError('');
    setShowForm(true);
  };

  const startEdit = (player) => {
    setNewUser({
      name: player.name || '',
      nickName: player.nickName || '',
      imgUrl: player.imgUrl || '',
      steamID: player.steamID || '',
    });
    setEditingId(player.steamID);
    setFormError('');
    setShowForm(true);
  };

  const FEHLERTEXT = {
    steamid: 'Steam ID nicht erkannt. Es muss die 17-stellige SteamID64 sein (STEAM_0:... wird umgerechnet).',
    exists: 'Diese Steam ID gehoert schon einem anderen Spieler.',
    invalid: 'Gamertag, echter Name und Steam ID sind noetig.',
    missing: 'Spieler nicht gefunden - vielleicht wurde er zwischenzeitlich entfernt.',
  };

  // Geht in die Datenbank -- frueher landete der Spieler nur in einer
  // Variablen und war beim naechsten Neustart wieder weg.
  const savePlayer = () => {
    setFormError('');

    const done = (result) => {
      if (!result || !result.ok) {
        setFormError(FEHLERTEXT[result && result.reason] || 'Speichern fehlgeschlagen.');
        return;
      }

      setNewUser(leeresFormular);
      setEditingId(null);
      setShowForm(false);
    };

    if (editingId) {
      socket.emit('roster:update', { ...newUser, originalId: editingId }, done);
    } else {
      socket.emit('roster:add', newUser, done);
    }
  };

  const removePlayer = (player) => {
    if (!window.confirm(`${player.nickName} wirklich aus dem Kader entfernen?`)) return;

    socket.emit('roster:remove', player.steamID, () => {
      if (editingId === player.steamID) {
        setShowForm(false);
        setEditingId(null);
      }
    });
  };



  return (
    <div>
      {!authenticated ? (
        <AdminLogin onLogin={handleLogin} /> // `onLogin` korrekt übergeben
      ) : (
        <div className='mx-auto max-w-3xl px-6 py-12 sm:py-16'>
          <h1 className='text-2xl pb-8'>Team Generator (Admin)</h1>

          {/* Anmeldung der Spieler. Der Code steht nur hier -- die
              Zuschauerseite ist oeffentlich im Internet. */}
          <section className='rounded-lg border border-gray-200 p-6'>
            <div className='flex flex-wrap items-center justify-between gap-4'>
              <div>
                <h2 className='text-lg font-semibold'>Lobby</h2>
                <p className='text-sm text-gray-500'>
                  {lobby.status === 'open'
                    ? 'Offen - Spieler koennen sich unter /join anmelden.'
                    : 'Geschlossen - niemand kann sich anmelden.'}
                </p>
              </div>

              <div className='flex items-center gap-3'>
                {lobby.status === 'open' && lobby.code && (
                  <div className='text-right'>
                    <div className='text-xs uppercase tracking-wide text-gray-500'>Code</div>
                    <div className='text-3xl font-bold tracking-[0.3em]'>{lobby.code}</div>
                  </div>
                )}
                <button
                  className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500'
                  onClick={lobby.status === 'open' ? closeLobby : openLobby}
                >
                  {lobby.status === 'open' ? 'Lobby schliessen' : 'Lobby oeffnen'}
                </button>
              </div>
            </div>

            <div className='mt-6'>
              <div className='flex items-center justify-between pb-3'>
                <span className='text-sm text-gray-500'>
                  Angemeldet: {lobby.claims.length} / {roster.length}
                </span>
                {lobby.claims.length > 0 && (
                  <button className='text-sm text-gray-500 underline' onClick={resetLobby}>
                    alle zuruecksetzen
                  </button>
                )}
              </div>

              {lobby.claims.length === 0 ? (
                <p className='text-sm text-gray-400'>Noch niemand angemeldet.</p>
              ) : (
                <ul className='grid grid-cols-1 gap-2 sm:grid-cols-2'>
                  {lobby.claims.map((claim) => (
                    <li
                      key={claim.playerId}
                      className='flex items-center justify-between rounded-md bg-gray-50 px-3 py-2'
                    >
                      <span className='truncate'>{claim.playerName}</span>
                      <button
                        className='ml-3 shrink-0 text-sm text-red-600 hover:underline'
                        onClick={() => releasePlayer(claim.playerId)}
                      >
                        freigeben
                      </button>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </section>

          {veto && (veto.running || veto.winner) && (
            <section className='mt-6 rounded-lg border border-gray-200 p-6'>
              <div className='flex flex-wrap items-center justify-between gap-4'>
                <div>
                  <h2 className='text-lg font-semibold'>Map-Veto</h2>
                  <p className='text-sm text-gray-500'>
                    {veto.winner
                      ? `Entschieden: ${veto.winner}`
                      : `${veto.bans.length} von ${veto.maps.length - 1} Banns`}
                  </p>
                </div>

                <div className='flex items-center gap-3'>
                  {veto.winner && (
                    <button
                      className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500'
                      onClick={() => {
                        const cmd = `matchzy_loadmatch_url "${window.location.origin}/match.json"`;
                        setCommand(cmd);
                        sendCommand(cmd);
                      }}
                    >
                      Match laden
                    </button>
                  )}
                  <button
                    className='text-sm text-gray-500 underline'
                    onClick={() => socket.emit('veto:cancel', null, () => {})}
                  >
                    Veto zuruecksetzen
                  </button>
                </div>
              </div>
            </section>
          )}

          <MapVeto veto={veto} identity={null} teamNames={[team1, team2]} isAdmin={true} />

          <div className='mt-10 grid grid-cols-1 sm:grid-cols-3 gap-y-3 gap-x-4'>
            <button className="rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600" onClick={generateTeams}>Teams generieren</button>
            <div></div>
            {/* Ready startet jetzt das Map-Veto. Die Konfiguration an den
                Gameserver zu schicken ergibt erst danach Sinn -- vorher steht
                die Map ja noch nicht fest. */}
            <Checkbox
              label="Ready"
              value={checked}
              onChange={handleChange2}
            />

          </div>
          {teams.length > 0 && (
            <div className='mt-10 grid grid-cols-1 sm:grid-cols-3 gap-y-3 gap-x-4'>
              <div>
                <input className='mb-8 text-xl font-bold' onBlur={handleOnBlur} onChange={handleChange} name="myInput" value={team1}></input>
                <ul>
                  {teams[0].map((user, index) => (
                    <li key={index} onClick={() => deleteMember(0, index)}>
                      <div className='flex flex-row mb-4'>
                        <img src={user.imgUrl} alt={user.nickName} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                        <span className='ml-2 my-auto'>{user.nickName} ({user.name})</span>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h2 className='p-4 sm:p-16 text-3xl font-bold'>VS</h2>
              </div>
              <div>
                <input className='mb-8 text-xl font-bold' onBlur={handleOnBlur1} onChange={handleChange1} name="myInput" value={team2}></input>
                <ul>
                  {teams[1].map((user, index) => (
                    <li key={index} onClick={() => deleteMember(1, index)}>
                      <div className='flex flex-row mb-4'>
                        <img src={user.imgUrl} alt={user.nickName} style={{ width: 50, height: 50, borderRadius: '50%' }} />
                        <span className='ml-2 my-auto'>{user.nickName} ({user.name})</span>
                        </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div>
                <h1>CS2 RCON Console</h1>
                <textarea
                  placeholder="Befehl eingeben..."
                  value={command}
                  onChange={(e) => setCommand(e.target.value)}
                />
                <button onClick={() => sendCommand(command)}>Senden</button>
                <pre>{response}</pre>
              </div>
            </div>
          )}
          <h3 className='mt-10 text-lg font-semibold'>Deactivated Members:</h3>
                  <ul>
                    {deactivated.map((member, index) => (
                      <li key={index} onClick={() => activateMember(member)} className='cursor-pointer'>
                        {member.name} ({member.nickName})
                      </li>
                    ))}
                  </ul>

          {/* Gameserver: Adresse fuer den Connect-Knopf und der RCON-Zugang.
              Beides lag frueher fest im Code bzw. in der .env. */}
          <section className='mt-6 rounded-lg border border-gray-200 p-6'>
            <div className='flex flex-wrap items-center justify-between gap-3'>
              <div>
                <h2 className='text-lg font-semibold'>Gameserver</h2>
                <p className='text-sm text-gray-500'>
                  {settings.gameHost
                    ? `Connect: ${settings.gameHost}:${settings.gamePort}`
                    : 'Keine Adresse hinterlegt - der Connect-Knopf bleibt ausgeblendet.'}
                </p>
                <p className='text-sm text-gray-500'>
                  RCON:{' '}
                  {settings.rconConfigured ? (
                    <span className='text-lime-700'>
                      eingerichtet ({settings.rconHost}:{settings.rconPort})
                    </span>
                  ) : (
                    <span className='text-amber-700'>kein Passwort hinterlegt</span>
                  )}
                </p>
              </div>

              <div className='flex items-center gap-3'>
                {settings.rconConfigured && (
                  <button className='text-sm text-gray-500 underline' onClick={clearRcon}>
                    RCON-Passwort loeschen
                  </button>
                )}
                <button
                  className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500'
                  onClick={serverForm ? () => setServerForm(null) : startServerEdit}
                >
                  {serverForm ? 'Abbrechen' : 'Bearbeiten'}
                </button>
              </div>
            </div>

            {serverForm && (
              <div className='mt-6 rounded-lg bg-gray-50 p-4'>
                <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                  <label className='block'>
                    <span className='block pb-1 text-sm text-gray-600'>Serveradresse</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2 font-mono'
                      placeholder='138.68.66.62'
                      value={serverForm.gameHost}
                      onChange={(e) => setServerForm({ ...serverForm, gameHost: e.target.value })}
                    />
                    <span className='block pt-1 text-xs text-gray-400'>
                      IP oder Hostname - dahin schickt der Connect-Knopf die Spieler
                    </span>
                  </label>

                  <label className='block'>
                    <span className='block pb-1 text-sm text-gray-600'>Spiel-Port</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2 font-mono'
                      placeholder='27015'
                      value={serverForm.gamePort}
                      onChange={(e) => setServerForm({ ...serverForm, gamePort: e.target.value })}
                    />
                  </label>

                  <label className='block'>
                    <span className='block pb-1 text-sm text-gray-600'>RCON-Adresse</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2 font-mono'
                      placeholder='138.68.66.62'
                      value={serverForm.rconHost}
                      onChange={(e) => setServerForm({ ...serverForm, rconHost: e.target.value })}
                    />
                    <span className='block pt-1 text-xs text-gray-400'>
                      Meist dieselbe wie oben
                    </span>
                  </label>

                  <label className='block'>
                    <span className='block pb-1 text-sm text-gray-600'>RCON-Port</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2 font-mono'
                      placeholder='27015'
                      value={serverForm.rconPort}
                      onChange={(e) => setServerForm({ ...serverForm, rconPort: e.target.value })}
                    />
                  </label>

                  <label className='block sm:col-span-2'>
                    <span className='block pb-1 text-sm text-gray-600'>RCON-Passwort</span>
                    <input
                      type='password'
                      autoComplete='new-password'
                      className='w-full rounded-md border border-gray-300 px-3 py-2'
                      placeholder={settings.rconConfigured ? 'unveraendert lassen' : 'rcon_password'}
                      value={serverForm.rconPassword}
                      onChange={(e) => setServerForm({ ...serverForm, rconPassword: e.target.value })}
                    />
                    <span className='block pt-1 text-xs text-gray-400'>
                      Leer lassen aendert nichts. Das Passwort wird nie wieder
                      angezeigt - nur ueberschrieben oder geloescht.
                    </span>
                  </label>
                </div>

                {serverError && (
                  <p className='mt-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700'>
                    {serverError}
                  </p>
                )}

                <div className='mt-4 flex items-center gap-3'>
                  <button
                    className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500'
                    onClick={saveServer}
                  >
                    Speichern
                  </button>
                  <button className='text-sm text-gray-500 underline' onClick={() => setServerForm(null)}>
                    Abbrechen
                  </button>
                </div>
              </div>
            )}
          </section>

          {/* Kader pflegen: anlegen und bearbeiten. Landet in der Datenbank,
              ein Rebuild des Frontends ist dafuer nicht noetig. */}
          <section className='mt-6 rounded-lg border border-gray-200 p-6'>
            <div className='flex flex-wrap items-center justify-between gap-3 pb-4'>
              <h2 className='text-lg font-semibold'>Kader ({roster.length})</h2>
              <button
                className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500'
                onClick={startAdd}
              >
                + Spieler hinzufuegen
              </button>
            </div>

            <ul className='divide-y divide-gray-100'>
              {roster.map((player) => (
                <li key={player.steamID} className='flex items-center gap-3 py-2'>
                  {player.imgUrl && (
                    <img
                      src={player.imgUrl}
                      alt={player.nickName}
                      style={{ width: 32, height: 32, borderRadius: '50%' }}
                    />
                  )}
                  <span className='min-w-0 flex-1'>
                    <span className='block truncate font-medium'>{player.name}</span>
                    <span className='block truncate text-sm text-gray-500'>
                      {player.nickName} - {player.steamID}
                      {!/^\d{17}$/.test(String(player.steamID)) && (
                        <span className='ml-2 rounded bg-amber-100 px-1.5 py-0.5 text-xs text-amber-800'>
                          keine SteamID64
                        </span>
                      )}
                    </span>
                  </span>
                  <button
                    className='shrink-0 text-sm text-indigo-600 hover:underline'
                    onClick={() => startEdit(player)}
                  >
                    bearbeiten
                  </button>
                  <button
                    className='shrink-0 text-sm text-red-600 hover:underline'
                    onClick={() => removePlayer(player)}
                  >
                    entfernen
                  </button>
                </li>
              ))}
            </ul>

            {showForm && (
              <div className='mt-6 rounded-lg bg-gray-50 p-4'>
                <h4 className='pb-3 font-semibold'>
                  {editingId ? 'Spieler bearbeiten' : 'Neuer Spieler'}
                </h4>

                <div className='grid grid-cols-1 gap-4 sm:grid-cols-2'>
                  <label className='block'>
                    <span className='block pb-1 text-sm text-gray-600'>Gamertag</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2'
                      placeholder='AtomOtter'
                      value={newUser.name}
                      onChange={(e) => setNewUser({ ...newUser, name: e.target.value })}
                    />
                    <span className='block pt-1 text-xs text-gray-400'>
                      Name im Spiel - so steht er auch in den Statistiken
                    </span>
                  </label>

                  <label className='block'>
                    <span className='block pb-1 text-sm text-gray-600'>Echter Name</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2'
                      placeholder='Krisz'
                      value={newUser.nickName}
                      onChange={(e) => setNewUser({ ...newUser, nickName: e.target.value })}
                    />
                    <span className='block pt-1 text-xs text-gray-400'>
                      Damit meldet er sich unter /join an
                    </span>
                  </label>

                  <label className='block sm:col-span-2'>
                    <span className='block pb-1 text-sm text-gray-600'>Steam ID</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2 font-mono'
                      placeholder='76561197961713091'
                      value={newUser.steamID}
                      onChange={(e) => setNewUser({ ...newUser, steamID: e.target.value })}
                    />
                    <span className='block pt-1 text-xs text-gray-400'>
                      SteamID64: 17 Ziffern, beginnt mit 7656119... - Beispiel
                      76561197961713091. Nicht die Form STEAM_0:0:7942230 (wird
                      aber automatisch umgerechnet). Nachschlagen z.B. auf steamid.io
                    </span>
                  </label>

                  <label className='block sm:col-span-2'>
                    <span className='block pb-1 text-sm text-gray-600'>Bild-URL</span>
                    <input
                      type='text'
                      className='w-full rounded-md border border-gray-300 px-3 py-2'
                      placeholder='https://avatars.steamstatic.com/....jpg'
                      value={newUser.imgUrl}
                      onChange={(e) => setNewUser({ ...newUser, imgUrl: e.target.value })}
                    />
                  </label>
                </div>

                {formError && (
                  <p className='mt-4 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700'>
                    {formError}
                  </p>
                )}

                <div className='mt-4 flex items-center gap-3'>
                  <button
                    className='rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500'
                    onClick={savePlayer}
                  >
                    Speichern
                  </button>
                  <button
                    className='text-sm text-gray-500 underline'
                    onClick={() => {
                      setShowForm(false);
                      setEditingId(null);
                      setFormError('');
                    }}
                  >
                    Abbrechen
                  </button>
                </div>
              </div>
            )}
          </section>

        </div>



      )
      }
    </div>
  );
};

const Checkbox = ({ label, value, onChange }) => {
  return (
    <label>
      <input type="checkbox" checked={value} onChange={onChange} />
      {label}
    </label>
  );
};




export default AdminView;
